import { fromUnixTime } from "date-fns/esm";

import { formatDate } from "utils/date";

export const getScanRunTitle = (createdAt: number) => formatDate({ date: fromUnixTime(createdAt) });
